export default __webpack_public_path__ + "static/media/prize_geprek_sambal_ori_mozza.9e936c39.png";